module.exports = new __parcel__URL__("giraffe.65216e18.svg").toString();